import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartPageModule } from './start-page/start-page.module';
import { TripMapModule } from './trip-map/trip-map.module';
import { RankingModule } from './ranking/ranking.module';
import { ResultModule } from './result/result.module';

@NgModule({
  imports: [
    CommonModule,
    StartPageModule,
    TripMapModule,
    RankingModule,
    ResultModule
  ],
  exports: [],
  declarations: []
})
export class ViewsModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/views.module.ts